<template>
  <div class="home fixed-draggable-dynamic-table-wrapper-height semi-box-border-y">
    <DraggableDynamicTable ref="userListTable"
                            :columns="columnsLabel"
                           :options="options"
                           @row:clicked="showUser"
                           @filter:remove="setFilter($event, true)"
                           @filter:set="setFilter($event)"
                           @sort:set="setSort($event)"
                           v-model="tableData"
    />

    <!-- insert new user prompt -->
    <custom-modal :active="insertPromptStatus"
                  :fixed-height="false"
                  @close="insertPromptStatus = false">
      <template #header>
        <div class="prompt-header p-3 w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
          <vs-row>
            <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
              <div @click="$u.click('insertUserBTN')">
                <custom-icon icon="SAVE" color="success"/>
              </div>
            </vs-col>

            <vs-spacer/>

            <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
              {{ $t('users.insert.title') }}
            </vs-col>

            <vs-spacer/>

            <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
              <div @click="insertPromptStatus = false">
                <custom-icon icon="circle-x-icon" color="danger"/>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </template>
      <template #content>
        <div class="prompt-content">
          <template>
            <keep-alive>
              <insert-user :in-modal="true" :set-role="false" @inserted="handleReloadTable" />
            </keep-alive>
          </template>
        </div>
      </template>
    </custom-modal>

    <button id="insertNewUser" v-show="false" @click="insertPromptStatus = true"></button>
  </div>
</template>

<script>
import Navbar from '../../../components/navbar/Navbar.vue'
import DraggableDynamicTable from '../../../components/draggableDynamicTable/draggableDynamicTable.vue'
import { getUsers } from '../../../http/requests/users'
import InsertUser from '@/views/users/insert/InsertUser.vue'
import CustomIcon from '@/components/icon/customIcon.vue'
import CustomModal from '@/components/modal/customModal.vue'
// import fa from '../i18n/locale/fa'

export default {
  name: 'UserList',
  components: {
    CustomModal,
    CustomIcon,
    InsertUser,
    Navbar,
    DraggableDynamicTable
  },

  metaInfo () {
    return {
      title: this.$t('users.list.title')
    }
  },

  data () {
    return {
      insertPromptStatus: false,
      options: {
        id: 'employeesList',
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'total_times',
          i18n: 'users.list.table.header.totalTime',
          width: '150px',
          minWidth: 150,
          align: 'center',
          /*filter: true,
          filterType: 'checkbox',
          filterTypes: []*/
          sortable: true,
          filter: true,
          filterTypes: [
            {
              icon: 'EQUAL',
              name: 'برابر باشد',
              id: 1
            },
            {
              icon: 'NOT_EQUAL',
              name: 'برابر نباشد',
              id: 2
            },
            {
              icon: 'GTE',
              name: 'بزرگتر مساوی',
              id: 3
            },
            {
              icon: 'LTE',
              name: 'کوچکتر مساوی',
              id: 4
            }
          ]
        },
        {
          field: 'email',
          i18n: 'users.list.table.header.email',
          width: 'calc((100% / 4))',
          minWidth: 150,
          align: 'center',
          filter: true,
          filterType: 'search',
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              id: 1
            }
          ],
          sortable: true
        },
        {
          field: 'name',
          i18n: 'users.list.table.header.name',
          width: 'calc((100% / 4) * 2)',
          minWidth: 150,
          align: 'center',
          filter: true,
          filterType: 'search',
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              id: 1
            }
          ],
          sortable: true
        },
        {
          field: 'id',
          i18n: 'users.list.table.header.row',
          width: '70px',
          minWidth: 70,
          align: 'center',
          autoIncrement: true,
          fixed: true,
          footer: {
            textType: 'price'
          }
        }
      ],
      loadingTimer: 0,
      endedList: false,
      tableData: [],
      filters: [],
      sorts: [],
      page: 1,
      actions: {
        toolbar: [
          {
            id: 'insertNewUser',
            icon: 'PLUS',
            iconPack: 'useral',
            color: 'success',
            permission: 'user.create'
          }
        ],
        leftToolbar: [
          {
            id: {name: 'usersTrash'},
            type: 'link',
            icon: 'bin-recycle-icon',
            iconPack: 'useral',
            permission: 'user.delete'
          }
        ]
      }
    }
  },

  created () {
    setTimeout(() => {
      this.getUser()
    }, 10)
  },

  mounted () {
    this.$nextTick(() => {
      this.$store.dispatch('updateNavbarActions', this.actions)
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
    })
  },

  methods: {
    getUser () {
      clearTimeout(this.loadingTimer)
      this.loadingTimer = setTimeout(() => {
        if (!this.endedList) {
          this.$refs.userListTable.loadMoreStatus = 'FirstLoad'
          if (this.$refs.userListTable && this.tableData.length === 0) {
            this.$refs.userListTable.loadMoreStatus = 'FirstLoad'
          } else if (this.$refs.userListTable && this.tableData.length > 0) {
            this.$refs.userListTable.loadMoreStatus = 'Loading'
          }
          this.endedList = true
          getUsers(this.page, this.filters, this.sorts)
            .then((response) => {
              this.endedList = response.data.pagination.current_page === response.data.pagination.total_pages

              const users = response.data.data
              // const users = []
              users.forEach((user) => {
                this.tableData.push({
                  id: user.id,
                  name: `${user.name || ''} ${user.family || ''}`,
                  email: {
                    value: user.email ? user.email : '',
                    route: user.email ? `mailto:${user.email}` : null,
                    routeType: 'external'
                  },
                  total_times: user.total_times ? user.total_times : 0
                })
              })

              this.page = response.data.pagination.current_page + 1
              const row_index = this.columnsLabel.map((e) => {
                return e.field
              }).indexOf('id')
              this.columnsLabel[row_index].footer.value = response.data.pagination.total

              if (this.$refs.userListTable) this.$refs.userListTable.loadMoreStatus = ''
            })
            .catch(() => {})
        }
      }, 400)

    },
    showUser (user) {
      this.$router.push({name: 'userTaskList', params: {id: user.id, user}})
    },
    setFilter (filters) {
      let filters_list = []
      const attributes = []
      Object.keys(filters).forEach((key) => {
        switch (key) {

        case 'id':
          if (filters[key].search !== '') filters_list.push(`id=${filters[key].search}`)
          break

        case 'name':
          if (filters[key].search !== '') filters_list.push(`fullName=${filters[key].search}`)
          break

        case 'email':
          if (filters[key].search !== '') filters_list.push(`email=${filters[key].search}`)
          break

        case 'total_times':
          if (filters[key].search !== '') filters_list.push(`totalTime=${filters[key].search}${filters[key].type.id > 1 ? `,${filters[key].type.id}` : ''}`)
          break
        }
      })
      filters_list = [filters_list, ...attributes]

      this.filters = filters_list
      this.handleReloadTable()
    },
    setSort (sorts) {
      const sorts_list = []
      Object.keys(sorts).forEach((key) => {
        switch (key) {

        case 'id':
          sorts_list.push(`order[0]=id,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'name':
          sorts_list.push(`order[0]=name,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'email':
          sorts_list.push(`order[0]=email,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'total_times':
          sorts_list.push(`order[0]=total_times,${  sorts[key] ? 'desc' : 'asc'}`)
          break
        }
      })

      if (sorts_list.length === 0) {
        this.sorts.push('order[0]=updated_at,desc')
      }

      this.sorts = sorts_list
      this.handleReloadTable()
    },
    handleReloadTable () {
      this.insertPromptStatus = false
      this.tableData = []
      this.page = 1
      this.endedList = false
      this.getUser()
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: calc(100vh - 90px);
}
</style>
